import styles from "./styles.module.css"

export default function InputText({ name, setValue, value, type, required }) {




    function handleChange(event) {
        if (type == "number" && name == "Desconto (%)") {
            const min = 0;
            const max = 100;
            const eventvalue = Math.max(min, Math.min(max, Number(event.target.value)));

            setValue(eventvalue);
        } else {
            setValue(event.target.value)
        }
    };

    return (
        <div className={styles.inputText}>
            <label htmlFor={name}>{name}</label>
            <input id={name} value={value} onChange={(event) => { handleChange(event); }} type={type} name={name} required={required} />
        </div>
    );
}